"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TrialModal = require("./TrialModal");
Object.keys(_TrialModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TrialModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TrialModal[key];
    }
  });
});